import { lazy } from 'react';

const AccessControlPage = lazy(() => import('../pages/AccessControl.page'));
const RolesListPage = lazy(() => import('../pages/RolesList.page'));
const RoleFormPage = lazy(() => import('../pages/RoleForm.page'));
const PermissionsCatalogPage = lazy(() => import('../pages/PermissionsCatalog.page'));
const UserRoleAssignmentPage = lazy(() => import('../pages/UserRoleAssignment.page'));

const AccessControlRoutes = [
    {
        path: '/access-control',
        children: [
            { element: <AccessControlPage />, layout: 'default', isAuthReq: true, index: true },
            { path: 'roles', element: <RolesListPage />, layout: 'default', isAuthReq: true },
            { path: 'roles/add', element: <RoleFormPage />, layout: 'default', isAuthReq: true },
            { path: 'roles/:id/edit', element: <RoleFormPage />, layout: 'default', isAuthReq: true },
            { path: 'permissions', element: <PermissionsCatalogPage />, layout: 'default', isAuthReq: true },
            { path: 'user-roles', element: <UserRoleAssignmentPage />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { AccessControlRoutes };
